import classnames from "classnames"
import parse from "html-react-parser"

import styles from "./hello_styles.module.scss"

interface Props {
  clickAccept: () => void
  clickAcceptUrl: string
  containerStyle: string
  ctaTitle: string
  declineCopy: string
  logoCover: string
  logoHtml: string
  mainBody: string
  mainTitle: string
  onClickDecline: () => void
}

const HelloCard = ({
  clickAccept,
  clickAcceptUrl,
  containerStyle,
  ctaTitle,
  declineCopy,
  logoCover,
  logoHtml,
  mainBody,
  mainTitle,
  onClickDecline,
}: Props) => {
  const clickAcceptHandler = event => {
    if (clickAccept) {
      event.preventDefault()
      clickAccept()
    }
  }
  return (
    <div className={classnames(styles["popup-container"], styles[containerStyle])}>
      <div className={styles["popup-card"]}>
        <a href={clickAcceptUrl} onClick={clickAcceptHandler}>
          <div className={styles["sla-img-container"]}>
            <MainImage image={logoHtml} />
            {logoCover && <span className={styles["logo-cover"]}>{parse(logoCover)}</span>}
          </div>
          <div className={styles.copy}>
            <h3>{mainTitle}</h3>
            <p>{mainBody}</p>
          </div>
        </a>
        <div className="action-buttons-container">
          {ctaTitle && (
            <a href={clickAcceptUrl} onClick={clickAcceptHandler} className="button-tertiary">
              {ctaTitle}
            </a>
          )}
          {declineCopy && (
            <button
              onClick={onClickDecline}
              className="button-tertiary button-cancel-link"
            >
              {declineCopy}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default HelloCard

const MainImage = ({ image }: { image: string }) =>
  image.includes("gif") ? <img src={image} /> : <div className={styles.logo}>{parse(image)}</div>
